import IcArrowExpand from './IcArrowExpand'

export default IcArrowExpand
